import type { Router } from 'vue-router';

/**
 * 사이드바 메뉴 Ctrl/Cmd+클릭 → 브라우저 새 탭.
 *
 * `el-menu-item` 은 `<a href>` 가 아니라 라우터 프로그래매틱 내비게이션이라 브라우저의
 * 기본 Ctrl+클릭(새 탭)이 동작하지 않는다. 코어 레이아웃(`AdminLayout`/`SidebarMenuNode`)을
 * 수정하지 않기 위해, 수정키를 누른 채 메뉴를 누른 직후 이어지는 라우터 내비게이션을
 * 가드에서 가로채 현재 탭 이동 대신 새 탭으로 연다.
 */
export function installMesMenuCtrlClickNewTab(router: Router): void {
  if (typeof document === 'undefined') return;

  /** 수정키+메뉴 클릭 직후의 내비게이션만 가로채기 위한 만료 시각(ms). */
  let armedUntil = 0;

  document.addEventListener(
    'pointerdown',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      const isMenuItem = Boolean(target?.closest('.el-menu .el-menu-item'));
      armedUntil = (event.ctrlKey || event.metaKey) && isMenuItem ? Date.now() + 600 : 0;
    },
    true,
  );

  router.beforeEach((to) => {
    if (armedUntil !== 0 && Date.now() <= armedUntil) {
      armedUntil = 0;
      window.open(router.resolve(to).href, '_blank', 'noopener');
      return false;
    }
    return true;
  });
}
